export default "__VITE_ASSET__CDHHc_Dz__"